import { defaultLevelFontSizes } from '../constants/heading-sizes.js';
import { FontWeight, LineHeight } from '../ContentText/types.js';
import { defaultLevelBottomMargins } from './styles.js';

var headingThemeWeb = {
  font: {
    weight: FontWeight.regular,
    lineHeight: LineHeight.normal
  },
  levelFontSizes: defaultLevelFontSizes,
  levelBottomMargins: defaultLevelBottomMargins
};
var headingThemeNative = {
  font: {
    weight: FontWeight.regular,
    lineHeight: LineHeight.normal
  },
  levelFontSizes: defaultLevelFontSizes,
  levelBottomMargins: defaultLevelBottomMargins
};

export { headingThemeNative, headingThemeWeb };
